import { render, staticRenderFns } from "./addBaseAcos.vue?vue&type=template&id=14b15b1a&scoped=true"
import script from "./addBaseAcos.vue?vue&type=script&lang=js"
export * from "./addBaseAcos.vue?vue&type=script&lang=js"
import style0 from "./addBaseAcos.vue?vue&type=style&index=0&id=14b15b1a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b15b1a",
  null
  
)

export default component.exports